import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Ensures users arriving via Supabase password recovery are routed to the reset page
const RecoveryRedirector: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    try {
      const searchParams = new URLSearchParams(location.search);
      const hasRecoveryQuery = searchParams.get('type') === 'recovery';
      const hasRecoveryHash = typeof window !== 'undefined' && window.location.hash.includes('type=recovery');
      const isRecovery = hasRecoveryQuery || hasRecoveryHash;

      if (isRecovery && location.pathname !== '/reset-password') {
        const hash = typeof window !== 'undefined' ? window.location.hash : '';
        navigate(`/reset-password${location.search}${hash}`, { replace: true });
      }
    } catch (e) {
      // Fail-safe: never crash the app from here
      console.warn('RecoveryRedirector warning:', e);
    }
  }, [location, navigate]);

  return null;
};

export default RecoveryRedirector;
